import React from 'react';
import { XCircle, CheckCircle2 } from 'lucide-react';
export const Comparison = () => {
  const rows = [{
    sin: 'Horas planificando desde cero cada semana',
    con: '5 minutos. Todo listo.'
  }, {
    sin: 'Ejercicios improvisados sin progresión',
    con: '+120 ejercicios graficados por nivel'
  }, {
    sin: 'Grupos sin sistema claro',
    con: 'Estructura clara para cada nivel y objetivo'
  }, {
    sin: 'Los padres preguntan "¿cuándo aprende el Axel?" y no sabés qué responder',
    con: 'Mostrás el progreso mes a mes con planillas concretas'
  }, {
    sin: 'Llegás al club agotado/a de inventar la clase',
    con: 'Llegás con el año resuelto y con energía para enseñar'
  }, {
    sin: 'Cobrar lo mismo de siempre porque no tenés nada para mostrar',
    con: 'Justificás el aumento de cuota mostrando el sistema profesional'
  }];
  return <section className="py-20 bg-white" data-id="element-39">
      <div className="max-w-5xl mx-auto px-4" data-id="element-40">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-41">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-42">
          <div className="grid grid-cols-2" data-id="element-43">
            <div className="bg-red-50 p-6 text-center border-b border-r border-red-100" data-id="element-44">
              <h3 className="text-xl font-bold text-red-700" data-id="element-45">SIN PATÍN 360</h3>
            </div>
            <div className="bg-green-50 p-6 text-center border-b border-green-100" data-id="element-46">
              <h3 className="text-xl font-bold text-green-700" data-id="element-47">
                CON PATÍN 360
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-48">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-49">
                <div className="p-6 bg-red-50/30 border-r border-red-50 flex items-start gap-3" data-id="element-50">
                  <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-51" />
                  <p className="text-gray-700 text-sm md:text-base" data-id="element-52">
                    {row.sin}
                  </p>
                </div>
                <div className="p-6 bg-green-50/30 flex items-start gap-3" data-id="element-53">
                  <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-54" />
                  <p className="text-gray-900 font-medium text-sm md:text-base" data-id="element-55">
                    {row.con}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-center text-xl font-bold text-gray-800 mt-12" data-id="element-56">
          El martes podés improvisar o entrar con todo resuelto. Vos decidís.
        </p>
      </div>
    </section>;
};